import axios from '@/axios.js'

export default {
  fetchDocuments({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/document-ledger', {
          params: payload,
        })
        .then((response) => {
          commit('SET_DOCUMENTS', response.data.data)
          commit('SET_PAGINATION', {
            currentPage: response.data.page,
            totalPage: response.data.totalPages,
            pageTotal: response.data.limit,
            totalItem: response.data.total,
          })
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchSummary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/document-ledger/summary', {
          params: payload,
        })
        .then((response) => {
          commit('SET_SUMMARY', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchFullSummary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/document-ledger/summary/full', {
          params: payload,
        })
        .then((response) => {
          commit('SET_FULL_SUMMARY', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  checkHasDocuments({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/document-ledger/check/has-documents')
        .then((response) => {
          commit('SET_HAS_DOCUMENTS', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

